export const requestTypeOptions = [
  { value: 'EXISTING_TIME_ADJUSTMENT', label: 'Existing time track adjustment' },
  { value: 'NEW_TIME_ENTRY', label: 'New time entry' },
];

export const activityOptions = [
  { value: 'HOME', label: 'Home' },
  { value: 'OFFICE', label: 'Office' },
  { value: 'TRANSIT', label: 'Transit' },
];
